module.exports = __webpack_public_path__ + "media/images/brand/400/MARQUESBRANDINGCO LOGO VERTICAL W-05e9a1596b1ec41a524a34c343e86859.png";